import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IconProp} from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-color-circle',
  templateUrl: './color-circle.component.html',
  styleUrls: ['./color-circle.component.scss']
})
export class ColorCircleComponent implements OnInit {
  @Input() color: string;
  @Input() active = false;
  @Input() icon: IconProp = {iconName: 'check', prefix: 'fas'};
  @Input() iconHidden = true;
  @Output() select = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
